module.exports = __webpack_public_path__ + "media/images/icons/ja-8f60548a91647c80dcb6b9599a693cc0.png";